import React from 'react';
import { menuCheckKey } from '../../../../OneHeader/hooks/useMenuItemCheck';

export enum MenuItemType {
    ExternalLink,
    ExternalLinkArrowed,
    InternalLink,
    Button,
}

export interface MenuItemInterface {
    title: string;
    url: string;
    itemType: MenuItemType;
    checkKey?: menuCheckKey;
    navDownCallback?: (event: React.MouseEvent) => void;
    icon?: React.ReactNode;
    hexColor?: string;
    className?: string;
    testId?: string;
    fullLoginRequired?: boolean;
    trackItemClick?: () => void;
    isNew?: boolean;
}

export interface MenuSectionInterface {
    key: string;
    title?: string;
    items: MenuItemInterface[];
}
